export function incomesReducer(state = "",{
    type,
    payload
}){
    
    switch(type){
        case "NEW_INCOME":            
        case "UPDATE_INCOME":
            let list = Object.assign({}, state);
            list[payload.income_id] = payload
            
            return list
        case "UPDATE_INCOME_PAYMENTS":
            let list2 = Object.assign({}, state);
            list2[payload.income_id].payments = payload.list
            
            return list2
        case "GET_INCOMES":
            return payload
        case "DELETE_INCOME":            
            let list4 = Object.assign({}, state);
    
            delete list4[payload.income_id]
            return list4
             
        default:
            return state;
    }
    
}